import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
const ExamLoadingScreen = () => /*#__PURE__*/_jsx("div", {
  children: /*#__PURE__*/_jsx("div", {
    style: {
      height: '100%',
      width: '100%'
    },
    children: /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      minHeight: 200
    })
  })
});
export default ExamLoadingScreen;